import { useState, useEffect, useMemo } from 'react';
import moment from 'moment-timezone';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
// import { useLoadAuthUser } from '../../../hooks/authhooks';
// import LoadingScreen from "../../shared/LoadingScreen";
import { ReactComponent as BackButtonIcon } from '../../../icons/BackButtonIcon.svg'
import { AddCircle } from "@mui/icons-material";
import homecook_logo from '../../../assets/img/homecook_logo.png'
// import { RegistrationForm } from './LoggedOutSelfServiceRegistration';
import { AddSelfServicePartnerModal, AddSelfServiceModal } from '../../../molecules/AppModal';
import { RegisteredPartner, SelfServiceDetailsMap, SelfServiceDetailsSchema } from '../../../data/types';
import { useSelfServiceRegistration, useSelfServices } from '../../../hooks/communityhook';
import LoadingScreen from '../../shared/LoadingScreen';
import { stylePhoneNumber } from '../../../utils/helpers';
import { useAuthState } from '../../../contexts/authcontext';



// const from_phone_style = (phone_number: string) => {
//   var cleaned_number = ('' + phone_number).replace(/\D/g, '')
//   return cleaned_number
// }


// type SelfServiceDetailsMap = Record<string, SelfServiceDetailsSchema>;

// Event details mapping
// const EVENT_DETAILS: SelfServiceDetailsMap = {
//   'springfest': {
//     id: 'springfest',
//     name: 'SpringFest 2025',
//     logo: 'https://dreamingoutloud.org/wp-content/uploads/2024/10/Dreaming-Out-Loud-Home-Logo-.webp',
//     organizer: 'Dreaming Out Loud',
//     organizer_url: 'https://dreamingoutloud.org',
//     date: 'April 15, 2025',
//     start_time: '10:00 AM',
//     end_time: '6:00 PM'
//   },
//   'summerfest': {
//     id: 'summerfest',
//     name: 'SummerFest 2025',
//     logo: 'https://dccentralkitchen.org/wp-content/uploads/2022/03/DCCentralKitchen_logo-hi-res-75x75.png',
//     organizer: 'DC Central Kitchen',
//     organizer_url: 'https://dccentralkitchen.org/',
//     date: 'July 20, 2025',
//     start_time: '9:00 AM',
//     end_time: '5:00 PM'
//   },
//   // Add more events as needed
// };

// interface NewSelfServiceFormData {
//   name: string;
//   code: string;
//   logo?: string;
//   organizer: string;
//   organizerUrl: string;
//   date: string;
//   startTime: string;
//   endTime: string;
//   isEditing: boolean;
// }

// const initialFormData: NewSelfServiceFormData = {
//   name: '',
//   code: '',
//   logo: '',
//   organizer: '',
//   organizerUrl: '',
//   date: '',
//   startTime: '',
//   endTime: '',
//   isEditing: false
// };

interface SelfServiceAdminProps {
  isloggedin: boolean;
}

const SelfServiceAdmin: React.FC<SelfServiceAdminProps> = ({isloggedin}) => {
  const navigate = useNavigate();
  const { event } = useParams();
  const location = useLocation();

  const { primaryCommunity } = useAuthState()
  const communityId = primaryCommunity?.id || ""
  const pathname = location.pathname;
  const isSelfServicePage = pathname === "/self-service" && !pathname.includes('/self-service/');
  const isSelfServiceEventPage = pathname.includes('/self-service/') && !pathname.includes('/self-service/event');
  // const { registerBusiness, isLoading } = useLoadAuthUser();
  // const [formData, setFormData] = useState({
  //   companyName: '',
  //   email: '',
  //   phone: '',
  //   eventCode: event || '',
  //   boothNumber: '',
  //   teamSize: '',
  //   firstName: '',
  //   lastName: '',
  //   signInMethod: 'email',
  //   registrationType: 'individual'
  // });
  // const [error, setError] = useState('');
  // const [lookupData, setLookupData] = useState({
  //   searchTerm: '',
  //   searchType: 'name' // 'name' or 'email'
  // });
  // const [searchResults, setSearchResults] = useState<any[]>([]);
  const [registeredUsers, setRegisteredUsers] = useState<RegisteredPartner[]>([]);
  // const [showRegisteredUsers, setShowRegisteredUsers] = useState(false);
  // const [showSearchResults, setShowSearchResults] = useState(false);
  // const [isSearchResultsCollapsed, setIsSearchResultsCollapsed] = useState(false);
  // const [showEventManagement, setShowEventManagement] = useState(false);
  // const [isEventManagementCollapsed, setIsEventManagementCollapsed] = useState(false);
  // const [eventFormData, setEventFormData] = useState<NewSelfServiceFormData>(initialFormData);
  const { selfServices } = useSelfServices();
  const [events, setEvents] = useState<SelfServiceDetailsMap>(selfServices || {});
  // const [activeTab, setActiveTab] = useState<'lookup' | 'registered' | 'form'>('form');
  
  
  // New state for registration modal
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  
  // New state for user count and pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const usersPerPage = 10;

  // Get self service details based on event code, return null if not found
  // const selfServiceDetails: SelfServiceDetailsSchema = event ? selfServices[event.toLowerCase()] || {} as SelfServiceDetailsSchema : {} as SelfServiceDetailsSchema;

  // Get self service details based on event code, return null if not found
  const selfServiceDetails = useMemo(() => {
    if (!selfServices) return {} as SelfServiceDetailsSchema;
    return event ? selfServices[event.toLowerCase()] || {} as SelfServiceDetailsSchema : {} as SelfServiceDetailsSchema;
  }, [event, selfServices]);
  
  // Only fetch registrations when on a specific event page with a valid event ID
  const shouldFetchRegistrations = isSelfServiceEventPage && !!selfServiceDetails?.id;
  const { selfServiceRegistrations, isLoading, reloadSelfServiceRegistrations } = useSelfServiceRegistration(
    shouldFetchRegistrations ? (selfServiceDetails?.id || '') : ''
  );

  // New state for venue modal
  const [showSelfServiceModal, setShowSelfServiceModal] = useState(false);

  // Keep event code in sync with URL parameter
  useEffect(() => {
    // if (event) {
    //   setFormData(prev => ({
    //     ...prev,
    //     eventCode: event
    //   }));
    //   setError('');
    // }

    window.document.title = `HomeCook | Self Service`;
    setEvents(selfServices || {});
    // Only update registered users when on an event page
    if (shouldFetchRegistrations && selfServiceRegistrations) {
      // Deduplicate users using a composite key to avoid incorrectly filtering valid users
      const users = selfServiceRegistrations as RegisteredPartner[];
      const seenKeys = new Set<string>();
      const uniqueUsers = users.filter((user, index) => {
        // Create a composite key using both id and email to ensure uniqueness
        // This prevents valid users with same email but different ids (or vice versa) from being filtered
        const idPart = (user.id && user.id.trim() !== '') ? user.id : `no-id`;
        const emailPart = (user.email && user.email.trim() !== '') ? user.email : `no-email-${index}`;
        const key = `${idPart}:${emailPart}`;
        
        if (seenKeys.has(key)) {
          return false;
        }
        seenKeys.add(key);
        return true;
      });
      setRegisteredUsers(uniqueUsers);
    } else if (isSelfServicePage) {
      // Clear registered users when on the main self services page
      setRegisteredUsers([]);
    }
    // setShowRegisteredUsers(true);
    // setCurrentPage(1);
  }, [event, selfServiceRegistrations, selfServices, selfServiceDetails, shouldFetchRegistrations, isSelfServicePage]);

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  // const handleCompanySelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   const selectedCompany = COMPANIES.find(company => company.id === e.target.value);
  //   if (selectedCompany) {
  //     setFormData(prev => ({
  //       ...prev,
  //       companyName: selectedCompany.name,
  //       boothNumber: selectedCompany.boothNumber
  //     }));
  //   }
  // };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   try {
  //     await registerBusiness(
  //       {
  //         name: formData.companyName,
  //         community_type: 'event_partner',
  //         active: true,
  //         description: `Event partner registration for ${formData.eventCode}`,
  //         services: 'event_exhibitor'
  //       },
  //       {
  //         email: formData.email,
  //         phone: formData.phone,
  //         username: formData.signInMethod === 'email' ? formData.email : formData.phone,
  //         first_name: formData.firstName,
  //         last_name: formData.lastName
  //       }
  //     );
  //     setShowRegistrationModal(false);
  //     handleViewRegisteredUsers(); // Refresh user list after registration
  //   } catch (error) {
  //     console.error('Registration failed:', error);
  //   }
  // };

  // const handleEventCodeSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const trimmedCode = formData.eventCode.trim();
    
  //   if (!trimmedCode) {
  //     setError('Please enter an event code');
  //     return;
  //   }

  //   if (trimmedCode.length < 3) {
  //     setError('Event code must be at least 3 characters long');
  //     return;
  //   }

  //   if (!EVENT_DETAILS[trimmedCode.toLowerCase()]) {
  //     setError('Invalid event code. Please check and try again.');
  //     return;
  //   }

  //   navigate(`/self-service/${trimmedCode}`);
  // };

  // const handleLookup = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   // TODO: Implement actual API call for lookup
  //   // For now, using mock data
  //   const mockResults = [
  //     { id: '1', name: 'John Doe', email: 'john@example.com', phone: '123-456-7890' },
  //     { id: '2', name: 'Jane Smith', email: 'jane@example.com', phone: '987-654-3210' }
  //   ];
  //   setSearchResults(mockResults);
  //   setShowSearchResults(true);
  //   setIsSearchResultsCollapsed(false);
  // };



  const handleViewRegisteredUsers = async () => {
    // setRegisteredUsers(mockUsers as RegisteredPartner[]);
    reloadSelfServiceRegistrations();
    // setShowRegisteredUsers(true);
    setCurrentPage(1);
  };
  
  // Handler for toggling sign in status
  const handleToggleSignIn = (email: string) => {
    setRegisteredUsers(prevUsers => 
      prevUsers.map(user => 
        user.email === email 
          ? { ...user, signed_in: !user.signed_in } 
          : user
      )
    );
  };
  
  // Filter and paginate users for the table
  const filteredUsers = registeredUsers ? registeredUsers.filter(user => 
    user?.first_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user?.last_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user?.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user?.organization?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user?.booth?.toLowerCase().includes(searchQuery.toLowerCase())
  ) : [];
  
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  
  // Open registration modal
  const openRegistrationModal = () => {
    setShowRegistrationModal(true);
  };
  
  // Close registration modal
  const closeRegistrationModal = () => {
    setShowRegistrationModal(false);
  };

  // const handleEventSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
    
  //   if (!eventFormData.name || !eventFormData.organizer || !eventFormData.organizerUrl || 
  //       !eventFormData.date || !eventFormData.startTime || !eventFormData.endTime) {
  //     alert('Please fill in all required fields');
  //     return;
  //   }

  //   const newEvent: EventDetailsSchema = {
  //     id: crypto.randomUUID(),
  //     name: eventFormData.name,
  //     organizer: eventFormData.organizer,
  //     organizerUrl: eventFormData.organizerUrl,
  //     date: eventFormData.date,
  //     startTime: eventFormData.startTime,
  //     endTime: eventFormData.endTime,
  //     logo: eventFormData.logo
  //   };
    
  //   setEvents(prev => ({
  //     ...prev,
  //     [eventFormData.code]: newEvent
  //   }));
    
  //   setEventFormData(initialFormData);
  //   setShowEventManagement(false);
  // };

  // const handleEditEvent = (code: string) => {
  //   const event = events[code];
  //   if (event) {
  //     setEventFormData({
  //       name: event.name,
  //       code,
  //       logo: event.logo || '',
  //       organizer: event.organizer,
  //       organizerUrl: event.organizerUrl,
  //       date: event.date,
  //       startTime: event.startTime,
  //       endTime: event.endTime,
  //       isEditing: true
  //     });
  //     setShowEventManagement(prev => !prev);
  //   }
  // };

  const handleEventCodeClick = (eventCode: string) => {
    navigate(`/self-service/${eventCode}`);
  };

  const openSelfServiceModal = () => {
    setShowSelfServiceModal(true);
  };
  
  const closeSelfServiceModal = () => {
    setShowSelfServiceModal(false);
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className={`w-full bg-[#F5F5F5] font-open-sans mt-[72px] h-auto min-h-screen flex flex-col justify-start`}>
      <div className="flex flex-row bg-white h-[75px] w-full">
          {/* Event Info Section */}
          {(selfServiceDetails?.id && isSelfServiceEventPage) ? (
            <>
              <button 
                  className="flex flex-row mx-8  h-[40px] w-[40px] rounded-full border-[1px] border-[#E9E9E9] font-raleway text-[16px] text-[#8A8A8A] my-auto p-2"
                  onClick={()=> navigate(`/self-service`)}
              >
                <BackButtonIcon  className="m-auto"/> 
              </button>
              <div className="flex items-center justify-between px-6 py-4">
                <div className="flex items-center space-x-4">
                  <div className="flex-shrink-0">
                    <img
                      className="h-12 w-12 object-contain"
                      src={selfServiceDetails?.logo || homecook_logo}
                      alt={`${selfServiceDetails?.organizer || 'HomeCook'} Logo`}
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = homecook_logo;
                      }}
                    />
                  </div>
                  <div>
                    <h1 className="text-xl font-semibold text-gray-900">{selfServiceDetails?.name || 'Event Registration'}</h1>
                    <p className="text-xs text-gray-500">
                      On <span className="text-primary-300 hover:text-primary-400 transition-colors">{selfServiceDetails?.date || 'HomeCook'}</span>
                    </p>
                  </div>
                </div>
              </div>
            </>
            ) : (
              <div className="flex items-center justify-between px-6 py-4">
                <h1 className="text-xl font-semibold text-gray-900">Access Management</h1>
              </div>
            )
          }
      </div>
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Event Header with Navigation */}
        {/* <div className="flex items-center mb-6">
          <button 
            onClick={() => navigate(-1)} 
            className="flex items-center text-gray-600 hover:text-gray-800"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
          </button>
          <div className="text-gray-600">
            Events / {selfServiceDetails?.name || 'Event Registration'}
          </div>
        </div> */}

        {/* Event Partner Branding */}
        {/* <div className="text-center mb-8">
          <div className="flex justify-center items-center space-x-4">
            {selfServiceDetails ? (
              <>
                <img
                  className="h-16 w-auto"
                  src={selfServiceDetails.logo || homecook_logo}
                  alt={`${selfServiceDetails.organizer} Logo`}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = homecook_logo;
                  }}
                />
                <div className="text-left">
                  <h1 className="text-3xl font-bold text-primary-200 font-gt-wl-pro">{selfServiceDetails.name}</h1>
                  <p className="text-[10px] text-back-200">
                    Powered by <a className="text-primary-300 hover:text-primary-400 transition-colors" href="https://homecookapp.com" target="_blank" rel="noopener noreferrer">HomeCook</a>
                  </p>
                </div>
              </>
            ) : (
              <>
                <img
                  className="h-16 w-auto"
                  src={homecook_logo}
                  alt="HomeCook Logo"
                />
                <div className="text-left">
                  <h1 className="text-3xl font-bold text-primary-200 font-gt-wl-pro">Venue Sign In | Registration</h1>
                  <p className="text-[10px] text-back-200">Powered by <a className="text-primary-300 hover:text-primary-400 transition-colors" href="https://homecookapp.com" target="_blank" rel="noopener noreferrer">HomeCook</a></p>
                </div>
              </>
            )}
          </div>
        </div> */}

        {!(isSelfServiceEventPage && selfServiceDetails?.id) ? (
          <>
            {/* Access Management Section - Only for logged-in users */}
            {isloggedin && (
              <div className="mt-8 w-full max-w-7xl mx-auto">
                {/* Header Section with Search and Add Button */}
                <div className="flex justify-between items-center mb-6">
                  <div className="text-sm text-gray-500">
                    {(() => {
                      const filteredEvents = Object.keys(events || {}).filter((code: string) => 
                        code && communityId && events[code]?.community_id && events[code]?.community_id === communityId
                      );
                      const count = filteredEvents.length;
                      if (count === 0) {
                        return `Showing 0 of 0 Events`;
                      }
                      return `Showing 1 - ${count} of ${count} Event${count !== 1 ? 's' : ''}`;
                    })()}
                  </div>
                  <div className="flex items-center space-x-4 flex-1 max-w-2xl mx-4">
                    <div className="relative flex-1">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                      </div>
                      <input
                        type="text"
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-primary-300 focus:border-primary-300 sm:text-sm"
                        placeholder="Search for event name, access code and organizer"
                      />
                    </div>
                  </div>
                  <button
                    onClick={openSelfServiceModal}
                    className="flex items-center space-x-2 px-4 py-2 bg-primary-200 text-white rounded-lg hover:bg-primary-400 transition-colors"
                  >
                    <AddCircle className="h-5 w-5" />
                    <span>Add Self Service</span>
                  </button>
                </div>

                {/* {showEventManagement && (
                  <form onSubmit={handleEventSubmit} className="space-y-4">
                    <div>
                      <label htmlFor="eventName" className="block text-sm font-medium text-primary-200">
                        Event Name
                      </label>
                      <input
                        type="text"
                        id="eventName"
                        value={eventFormData.name}
                        onChange={(e) => setEventFormData(prev => ({ ...prev, name: e.target.value }))}
                        className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                        placeholder="Enter event name"
                        required
                      />
                    </div>

                    <div>
                      <label htmlFor="event_code" className="block text-sm font-medium text-primary-200">
                        Access Code
                      </label>
                      <input
                        type="text"
                        id="event_code"
                        value={eventFormData.code}
                        onChange={(e) => setEventFormData(prev => ({ ...prev, code: e.target.value }))}
                        className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                        placeholder="Enter event code"
                        required
                        disabled={eventFormData.isEditing}
                      />
                    </div>

                    <div>
                      <label htmlFor="eventLogo" className="block text-sm font-medium text-primary-200">
                        Event Logo URL
                      </label>
                      <input
                        type="url"
                        id="eventLogo"
                        value={eventFormData.logo}
                        onChange={(e) => setEventFormData(prev => ({ ...prev, logo: e.target.value }))}
                        className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                        placeholder="Enter logo URL"
                      />
                    </div>

                    <div>
                      <label htmlFor="eventOrganizer" className="block text-sm font-medium text-primary-200">
                        Organizer Name
                      </label>
                      <input
                        type="text"
                        id="eventOrganizer"
                        value={eventFormData.organizer}
                        onChange={(e) => setEventFormData(prev => ({ ...prev, organizer: e.target.value }))}
                        className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                        placeholder="Enter organizer name"
                        required
                      />
                    </div>

                    <div>
                      <label htmlFor="eventOrganizerUrl" className="block text-sm font-medium text-primary-200">
                        Organizer Website
                      </label>
                      <input
                        type="url"
                        id="eventOrganizerUrl"
                        value={eventFormData.organizerUrl}
                        onChange={(e) => setEventFormData(prev => ({ ...prev, organizerUrl: e.target.value }))}
                        className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                        placeholder="Enter organizer website URL"
                        required
                      />
                    </div>

                    <div>
                      <label htmlFor="eventDate" className="block text-sm font-medium text-primary-200">
                        Event Date
                      </label>
                      <input
                        type="date"
                        id="eventDate"
                        value={eventFormData.date}
                        onChange={(e) => setEventFormData(prev => ({ ...prev, date: e.target.value }))}
                        className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                        required
                      />
                    </div>

                    <div className="flex space-x-4">
                      <div className="flex-1">
                        <label htmlFor="startTime" className="block text-sm font-medium text-primary-200">
                          Start Time
                        </label>
                        <input
                          type="time"
                          id="startTime"
                          value={eventFormData.startTime}
                          onChange={(e) => setEventFormData(prev => ({ ...prev, startTime: e.target.value }))}
                          className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                          required
                        />
                      </div>
                      <div className="flex-1">
                        <label htmlFor="endTime" className="block text-sm font-medium text-primary-200">
                          End Time
                        </label>
                        <input
                          type="time"
                          id="endTime"
                          value={eventFormData.endTime}
                          onChange={(e) => setEventFormData(prev => ({ ...prev, endTime: e.target.value }))}
                          className="mt-1 block w-full border border-back-400 rounded-lg shadow-sm py-3 px-4 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 text-primary-200 placeholder-back-300"
                          required
                        />
                      </div>
                    </div>

                    <div className="flex justify-end">
                      <button
                        type="submit"
                        className="px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-primary-300 hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-300 transition-colors"
                      >
                        {eventFormData.isEditing ? 'Update Event' : 'Create Event'}
                      </button>
                    </div>
                  </form>
                )} */}

                {/* Events Table */}
                <div className="bg-white shadow-sm rounded-lg overflow-hidden">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Event Name
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Access Code
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Event Date
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Event Time
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Organizer
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Registered Users
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {Object.entries(events || {}).map(([code, details]) => (code && communityId && details.community_id && details.community_id === communityId) ?(
                        <tr key={code} className="hover:bg-gray-50">
                          <td onClick={() => handleEventCodeClick(code)} className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 cursor-pointer">
                            {details.name}
                          </td>
                          <td onClick={() => handleEventCodeClick(code)} className="px-6 py-4 whitespace-nowrap text-sm text-primary-200 cursor-pointer">
                            {code}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {details.date}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {details.start_time} - {details.end_time}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {details.organizer}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                            -
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <div className="flex space-x-4">
                              <button
                                onClick={() => handleEventCodeClick(code)}
                                className="text-gray-400 hover:text-gray-500"
                              >
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                              </button>
                              <button
                                // onClick={() => handleEditEvent(code)}
                                className="text-gray-400 hover:text-gray-500"
                              >
                                <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ) : (<></>))}
                    </tbody>
                  </table>
                  <div className="bg-white px-4 py-3 flex items-center justify-center">
                    <div className="flex-1 flex justify-center">
                      <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                        <div className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white">
                          Page 1
                        </div>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Self Service Modal Modal */}
            <AddSelfServiceModal
              isOpen={showSelfServiceModal}
              closeAppModal={closeSelfServiceModal}
            />
          </>
        ) : (
          <>
            {/* Registered Users View - Updated to match design */}
            <div className="bg-white shadow-lg rounded-xl overflow-hidden mt-8 w-full ">
              {/* Header with user count and search */}
              <div className="p-4 border-b flex flex-wrap justify-between items-center">
                <div className="text-sm text-gray-600">
                  Showing {(filteredUsers.length > 0) ? indexOfFirstUser + 1 : 0} - {Math.min(indexOfLastUser, filteredUsers.length)} of {filteredUsers.length} Registered Users
                </div>
                
                {/* Search and Register Buttons */}
                <div className="flex space-x-2 items-center">
                  {/* Search Input */}
                  <div className="relative">
                    <input
                      type="text"
                      placeholder="Search for name"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300"
                    />
                    <svg 
                      className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                  </div>
                  
                  {/* Registration Form Button */}
                  <button
                    onClick={openRegistrationModal}
                    className="px-4 py-2 bg-primary-200 text-white rounded-md hover:bg-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:ring-offset-2"
                  >
                    <AddCircle className="mr-2 my-auto" />
                    Add New User
                  </button>
                  
                  {/* Refresh Button */}
                  <button 
                    onClick={handleViewRegisteredUsers}
                    className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100"
                  >
                    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                  </button>
                </div>
              </div>
              
              {/* Table of Registered Users */}
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone Number</th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Organization</th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Booth</th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Check-in Status</th>
                      <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Check In Time</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {currentUsers.length > 0 ? (
                      currentUsers.map((user, index) => (
                        <tr key={user.id ? `${user.id}-${index}` : user.email ? `${user.email}-${index}` : `user-${index}`}>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">{user.first_name} {user.last_name}</td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">{user.email}</td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">{stylePhoneNumber(user?.phone || '')}</td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">{user.organization}</td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">{user.booth}</td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <div className="flex items-center">
                              {/* <span className={`mr-2 text-sm ${user.signed_in ? 'text-green-600' : 'text-red-600'}`}>
                                {user.signed_in ? 'Checked In' : 'Not Checked In'}
                              </span> */}
                              <span className="mr-2 text-sm text-green-600">
                                Checked In
                              </span>
                              <button
                                disabled={user.signed_in}
                                onClick={() => handleToggleSignIn(user?.email || '')}
                                className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ease-in-out ${
                                  user.email ? 'bg-green-500' : 'bg-gray-300'
                                }`}
                              >
                                <div className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${
                                  user.email ? 'translate-x-6' : 'translate-x-0'
                                }`}></div>
                              </button>
                            </div>
                          </td>
                          <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-800">{user.created ? moment(user.created).format('MM/DD/YYYY hh:mm A') : '-'}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="px-6 py-4 text-center text-sm text-gray-500">
                          No registered users found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              
              {/* Pagination */}
              {totalPages > 1 && (
                <div className="px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                  <div className="flex-1 flex justify-center">
                    <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                      <button
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                        className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${
                          currentPage === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'
                        }`}
                      >
                        <span className="sr-only">Previous</span>
                        <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      </button>
                      
                      {Array.from({ length: totalPages }).map((_, index) => (
                        <button
                          key={index}
                          onClick={() => setCurrentPage(index + 1)}
                          className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${
                            currentPage === index + 1
                              ? 'z-10 bg-primary-300 border-primary-300 text-white'
                              : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'
                          }`}
                        >
                          {index + 1}
                        </button>
                      ))}
                      
                      <button
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages}
                        className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${
                          currentPage === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'
                        }`}
                      >
                        <span className="sr-only">Next</span>
                        <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </nav>
                  </div>
                </div>
              )}
            </div>
            
            {/* Registration Form Modal */}
           
            <AddSelfServicePartnerModal
              selfServiceDetails={selfServiceDetails}
              isLoggedIn={isloggedin}
              isOpen={showRegistrationModal}
              closeAppModal={closeRegistrationModal}
            />
        
          </>
        )}
      </div>
    </div>
  );
};




export default SelfServiceAdmin; 